// App user stored in our database (not the Privy SDK user)
// Matches current API structure (api/src/user/user_types.rs)
// Note: API serializes with camelCase (via #[serde(rename_all = "camelCase")])

export interface User {
  id: string
  privyId: string
  email?: string
  normalizedEmail?: string
  role: UserRole
  isSuspended: boolean
  referredBy?: string
  createdAt: string
  updatedAt: string
  normalizedEmailCount?: number
}

// UserRole enum matching API's lowercase serialization
export enum UserRole {
  Mobile = 'mobile',
  Extension = 'extension',
  Explorer = 'explorer',
  Desktop = 'desktop',
}
